import { CadreDeLAppDuChat } from "@dust-tt/front/components/compta/CadreDeLApp";
import { AppContentLayout } from "@dust-tt/front/components/sparkle/AppContentLayout";
import { AppLayoutProvider } from "@dust-tt/front/components/sparkle/AppLayoutContext";
import { ConversationFontProvider } from "@dust-tt/front/components/sparkle/ConversationFontContext";
import { useWorkspace } from "@dust-tt/front/lib/auth/AuthContext";
import { Outlet } from "react-router-dom";

/**
 * Router layout that provides the shared AppContentLayout (navigation sidebar, title bar, etc.)
 * for SPA routes. Pages configure the layout via useAppLayoutConfig().
 *
 * Routes that don't need the layout chrome (onboarding, agent/skill builders)
 * should be placed outside this layout.
 */
export function AppContentRouterLayout() {
  const owner = useWorkspace();
  return (
    <AppLayoutProvider>
      <ConversationFontProvider>
        <AppContentLayout>
          {/* compta, coquille : la page de l'app, gardee en vie entre toutes les pages du chat
              (conversations, espaces, constructeur d'assistants). */}
          <CadreDeLAppDuChat owner={owner} />
          <Outlet />
        </AppContentLayout>
      </ConversationFontProvider>
    </AppLayoutProvider>
  );
}
